var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w-5 h-5 border-4 border-teal-600 rounded-full inline-block t-loader",class:_vm.extraClass})}
var staticRenderFns = []

export { render, staticRenderFns }